import { AdEvent } from '@/enums/ima-ad-event';
import { VideoJsImaPlayer, VideoJsPlayerStatus } from '@/interfaces/components/videojs-ima-player';

type loadingStatus = 'idle' | 'loaded' | 'error';
export class VideojsImaHelper {
	private static _gadsScriptsStatus: loadingStatus = 'idle';

	static get gadsScriptsStatus() {
		return VideojsImaHelper._gadsScriptsStatus;
	}

	private static loadScript(src: string) {
		return new Promise((resolve, reject) => {
			const gads = document.createElement('script');
			gads.async = true;
			gads.defer = true;
			gads.type = 'text/javascript';
			gads.src = src;
			const node = document.getElementsByTagName('script')[0];
			node?.parentNode?.insertBefore(gads, node);
			gads.onload = () => {
				resolve(null);
			};
			gads.onerror = () => {
				reject(null);
			};
		});
	}
	static async loadGoogleAdsScripts() {
		if (VideojsImaHelper.gadsScriptsStatus == 'idle') {
			try {
				const scripts = [
					'//www.googletagservices.com/tag/js/gpt.js', // found in other component TODO: check if we should remove it
					'//imasdk.googleapis.com/js/sdkloader/ima3.js',
				].map(src => VideojsImaHelper.loadScript(src));
				/*@ts-ignore*/
				await Promise.all([
					...scripts,
					/*@ts-ignore*/
					import('videojs-contrib-ads'),
				]);
				VideojsImaHelper._gadsScriptsStatus = 'loaded';
			} catch (error) {
				VideojsImaHelper._gadsScriptsStatus = 'error';
			}
		}
	}

	static async init() {
		await VideojsImaHelper.loadGoogleAdsScripts();
	}

	static adsManagerLoadedCallback(player: VideoJsImaPlayer | null, callback: (event: { type: AdEvent }) => void) {
		const events = [AdEvent.COMPLETE, AdEvent.STARTED, AdEvent.ALL_ADS_COMPLETED];

		for (let index = 0; index < events.length; index++) {
			player?.ima.addEventListener(events[index], callback);
		}
	}

	static isAdsNotPlaying(eventType: VideoJsPlayerStatus, adsStatus: AdEvent | undefined) {
		if (adsStatus === AdEvent.STARTED) {
			return false;
		} else if (eventType === 'ended' && (!adsStatus || adsStatus !== AdEvent.ALL_ADS_COMPLETED)) {
			return false;
		}
		return true;
	}
}
